import React, { useState } from 'react';
import { Upload, message, Button, Icon } from 'antd';

import config from '../../config';
import SelectType from './SelectType';
import { withOrderFormContext } from '../../contexts';

const UploadSignatureComponent = ({ setSignature }) => {
  const [fileList, setFileList] = useState([]);

  const props = {
    name: 'file',
    action: `${config.uploadBaseUrl}/api/v1/upload-signature`,
    headers: {
      Authorization: `Bearer ${config.uploadAuthorization}`
    },
    onChange({ file, fileList }) {
      if (file.status === 'done') {
        message.success(`${file.name} file uploaded successfully`);

        file.url = file.response?.data?.url || '';
        setSignature && setSignature(file.url);

      } else if (file.status === 'error') {
        console.log(file);
        message.error(`${file.name} file upload failed. ${file.response?.message}`);
      }

      setFileList(fileList.slice(-1));
    }
  };

  return (
    <Upload {...props} fileList={fileList}>
      <Button>
        <Icon type="upload" /> Click to Upload ($10.00).
      </Button>
    </Upload>
  );
};

const UploadSignature = withOrderFormContext(context => ({
  setSignature: context.setSignature
}))(UploadSignatureComponent);

const SignatureType = ({ attribute, value, onChange }) => {
  return (
    <>
      <SelectType
        value={value}
        attribute={attribute}
        onChange={onChange}
      />

      {(value && String(value).toLowerCase() === 'yes') &&
        <UploadSignature />
      }
    </>
  );
};

export default SignatureType;
